import propTypes from 'prop-types';
import { inject } from 'mobx-react';

const _CallUs = ({ labelsStore, optionsStore }) => (
  <>
    {optionsStore.callUsURL

      ? (
        <a
          href={optionsStore.callUsURL}
          className="cart-link pes-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {labelsStore.giftlistContactUsText}
        </a>
      )

      : <span className="cart-link">{labelsStore.giftlistContactUsText}</span>}

  </>
);

_CallUs.propTypes = {
  labelsStore: propTypes.shape({
    giftlistContactUsText: propTypes.string.isRequired
  }).isRequired,
  optionsStore: propTypes.shape({
    callUsURL: propTypes.string
  }).isRequired
};

export const CallUs = inject((allStores) => ({
  labelsStore: allStores.labelsStore,
  optionsStore: allStores.optionsStore
}))(_CallUs);
